module.exports = __webpack_public_path__ + "img/creativo-minuscules.2df8758b.jpg";